import { useState } from "react";
import { ArrowCounterClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { fmtBRL } from "../lib/format";

const input = "bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500";

export const ReverseCreditEntry = ({ clientId, entry, onReversed }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post(`/clients/${clientId}/credits/${entry.id}/reverse`, { reason });
      toast.success(`${fmtBRL(data.reversed)} devolvidos ao crédito (agora ${fmtBRL(data.client_credit)}) — pedido #${data.order_code} voltou a ${fmtBRL(data.order_balance)} em aberto`, { duration: 8000 });
      setOpen(false);
      setReason("");
      onReversed && onReversed(data);
    } catch (err) {
      toast.error(apiError(err));
    }
    setSaving(false);
  };

  if (!open) {
    return (
      <button type="button" data-testid={`reverse-credit-button-${entry.id}`} onClick={() => setOpen(true)}
        className="mt-1 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.1em] text-amber-400 hover:text-amber-300 transition-colors">
        <ArrowCounterClockwise size={12} /> Estornar
      </button>
    );
  }
  return (
    <form onSubmit={submit} data-testid={`reverse-credit-form-${entry.id}`} className="mt-2 border border-amber-400/30 rounded p-2 space-y-2">
      <p className="text-[10px] uppercase tracking-[0.1em] text-amber-400">Estornar {fmtBRL(-entry.amount)} — remove o pagamento do pedido #{entry.order_code} e devolve ao crédito</p>
      <input data-testid={`reverse-credit-reason-${entry.id}`} className={`${input} w-full`} placeholder="Motivo (opcional)"
        value={reason} onChange={(e) => setReason(e.target.value)} />
      <div className="flex gap-2">
        <button data-testid={`reverse-credit-confirm-${entry.id}`} disabled={saving}
          className="flex-1 flex items-center justify-center gap-1.5 bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white text-xs font-medium py-1.5 rounded transition-colors">
          <ArrowCounterClockwise size={13} weight="bold" /> {saving ? "Estornando..." : "Confirmar estorno"}
        </button>
        <button type="button" data-testid={`reverse-credit-cancel-${entry.id}`} onClick={() => setOpen(false)}
          className="px-3 border border-zinc-700 hover:bg-zinc-800 text-zinc-300 text-xs rounded transition-colors">Cancelar</button>
      </div>
    </form>
  );
};
